

import { Container } from 'inversify';
import { computed, defineComponent, onMounted, ref } from 'vue';
import { clave } from '../../dataupdate/domain/clave';
import Search from './search/Search.vue'
import SearchDetail from './search/SearchDetail.vue'
import SkeletonCrudTable from '../../../../common/infrastructure/componentes/base/common/skeleton/SkeletonCrudTable.vue'
import { IapCatalog } from '../../catalog/domain/iapCatalog';
import { SearchData } from '../../search/domain/search';
import DataSourceComp from './functions/dataSourceComp';
import { IapComponentDataSource } from '../../component/domain/iapComponentDataSource';
import { IapComponent } from '../../component/domain/iapComponent';
import CatalogTypeConst from '../../../../common/domain/constantes/CatalogTypeConst';
import FiltroBusquedaConst from '../../../../common/domain/constantes/FiltroBusquedaConst';
import { MenuItem } from 'primevue/menuitem';
import { IServiceSearch } from '../../search/application/IServiceSearch';
import { TYPES } from '../../../../common/domain/types';
import HelperLoading from '../../../../common/infrastructure/funciones/HelperLoading';
import HelperUtils from '../../../../common/infrastructure/funciones/HelperUtils';
import { useStore } from 'vuex';
import helperCatalog from '../../catalog/infrastructure/helper/helperCatalog';

export default defineComponent({
    name: 'crud_table_builder',

    props: {
        container: {
            type: Object as () => Container
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },

        Component: {
            type: Object as () => IapComponent,
            default: () => ({})
        },

        showBtnSearch: {
            type: Boolean,
            default: true
        },
        showBtnClear: {
            type: Boolean,
            default: true
        },
        showBtnCloseTabs: {
            type: Boolean,
            default: false
        },

        editAllExceptKeys: {
            type: Boolean,
            default: false
        },


        maxRegs: {
            type: Number,
            default: 100
        },
        canAddNewItem: {
            type: Boolean,
            default: false
        },
        canImport: {
            type: Boolean,
            default: false
        },
        canDeleteItem: {
            type: Boolean,
            default: false
        },
        canUpdateMassive: {
            type: Boolean,
            default: true
        },
        showActionMenu: {
            type: Boolean,
            default: false
        },
        showSearch: {
            type: Boolean,
            default: true
        },
        showResultFromCustomfilter: {
            type: Object as () => clave[],
            default: () => ([])
        },
        showActionDetail: {
            type: Boolean,
            default: false
        },
        showPaginate: {
            type: Boolean,
            default: true
        },
        menuActionItems: {
            type: Object as () => MenuItem[],
            default: []
        },
        showPaginator: {
            type: Boolean,
            default: true
        },
        showHeaderDetail: {
            type: Boolean,
            default: true
        },
        customAddNew: {
            type: Boolean,
            default: false
        },


    },
    emits: ['click:action', 'closealltabs', 'click:viewDetail','click:SelectRow','click:addCustom'],
    components: {
        SkeletonCrudTable,
        Search,
        SearchDetail

    },

    setup(props, { emit }) {
        const store = useStore();
        const datasource = ref<IapComponentDataSource>();
        const searchComp = ref();
        const catalogos = ref<IapCatalog[]>([]);
        const dataSearchFilter = ref<Partial<SearchData>[]>([]);
        const dataSearchResult = ref();
        const hasLoadCustomSearchData = ref(false)
        

        const hasData = computed(() => {
            return datasource.value && datasource.value.dataSource.iapDataSourceFields.length > 0 && datasource.value?.dataSource?.iapDataSourceDataBase?.idBaseDatos && catalogos.value.length > 0 && (hasLoadCustomSearchData.value == true);
        })


        const filterTables = computed(() => {
            const aux = dataSearchFilter.value.map(x => x.field?.tableName)
            const uniqueIds = [...new Set(aux)];
            return (uniqueIds ?? []) as any
        })

        const fillDataSearchFilters = () => {
            const claves = datasource.value?.dataSource.iapDataSourceFields.filter(x => x.filterValue).map(x =>
            ({
                field: x,
                filter: FiltroBusquedaConst.FILTROBUSQUEDA_IGUAL,
                value: x.filterValue,
                valueList: (x.catalogTypeId ? [x.filterValue] : null),
                valueBool: null,
                valueNumber: null,
                valueDateTime: null,
                rangeValue: null,
                rangeNumber: null,
                rangeDateTime: null

            }));

            if (claves) {
                /*try{
                    dataSearchFilter.value = dataSearchFilter.value.concat(claves as any)
                }catch{}
                */
                
                claves.forEach((clave:any) =>
                {
                    if (dataSearchFilter.value.find( (r:any)=> r.field.id == clave.field.id ) == undefined){
                        dataSearchFilter.value.push(clave as any)
                    }                    
                })
                
                
                
            }
        }

        const doRefreshData = () => {
            if (props.container) {
                
                const clearEmpyyFiltersList = dataSearchFilter.value.filter( x=> x.field && ((x.field.catalogTypeId == null) || x.field.catalogTypeId !== null && (x.valueList?.length ?? 0) > 0 ));
                clearEmpyyFiltersList.forEach(item => {
                    if (item.field && item.field.dataSourceLookUp){
                         item.field.dataSourceLookUp = null;
                    }
                    
                })

                let data = JSON.parse(JSON.stringify(clearEmpyyFiltersList));
                const _srv = props.container.get<IServiceSearch>(
                    TYPES.SEARCH_REPOSITORY
                );
                HelperLoading.showLoading();
                _srv.search(props.Component.applicationId, props.Component.applicationVersion, props.Component.id,
                    data as any, datasource.value?.maxRowsReturned ?? 100, datasource.value?.id ?? -1)
                    .then((response) => {
                        const { generateFormatCol } = DataSourceComp(props.container as any, props, emit, {}, datasource.value as any, catalogos.value,store)
                        const obj = JSON.parse(response?.items ?? '[]');
                        generateFormatCol(obj)
                        HelperUtils.handleDates(obj)
                        dataSearchResult.value = obj
                    })
                    .finally(() => {
                        HelperLoading.hideLoading();
                        data = null;
                    });

            }

        }


        const doSearch = () => {
            const { generateFormatCol } = DataSourceComp(props.container as any, props, emit, {}, datasource.value as any,catalogos.value,store)
            hasLoadCustomSearchData.value = true
            if (datasource.value?.autoLoad) {
                fillDataSearchFilters();
                const obj = datasource.value.dataSource?.items ?? [];
                generateFormatCol(obj)
                dataSearchResult.value = obj;
                if (obj.length > 0 && dataSearchFilter.value?.length == 0) {

                    datasource.value.dataSource.iapDataSourceFields.filter(x => datasource.value?.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.defaultFilterSearch)
                        .sort((a, b) => { return (datasource.value?.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.defaultFilterSearchOrder ?? 0) - (datasource.value?.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.defaultFilterSearchOrder ?? 0); })
                        .forEach(c => {
                            dataSearchFilter.value.push({
                                field: c as any,
                                filter: FiltroBusquedaConst.FILTROBUSQUEDA_CONTIENE,
                                //tableName:props.tablas.find(x=> x.tableName == c.tableName)?.tableAlias ?? props.tablas.find(x=> x.tableName == c.tableName)?.tableName,
                                //tableIcon: props.tablas.find(x=> x.tableName == c.tableName)?.idIcon ?? 'pi pi-list',
                            } as any)
                        })

                }
            }
            /*
            if (props.showResultFromCustomfilter.length > 0 && estructuraBd.value) {
                const campos = props.showResultFromCustomfilter.map(x => x.campo.toLocaleLowerCase())
                const firstTabla = props.tablas[0]
                estructuraBd.value.filter(x => x.dataSource?.idTabla?.toLocaleLowerCase() == firstTabla.toLocaleLowerCase() && campos.includes(x.field.toLocaleLowerCase()))
                    .forEach(c => {
                        dataSearchFilter.value.push({
                            field: c as any,
                            //seleccionado: true,
                            filter: FiltroBusquedaConst.FILTROBUSQUEDA_IGUAL,
                            value: props.showResultFromCustomfilter.find(x => x.campo.toLocaleLowerCase() == c.field.toLocaleLowerCase())?.valor ?? ''
                        } as any)
                    })
                if (props.container && dataSearchFilter.value.length > 0) {
                    const _srv = props.container.get<IServiceBuscar>(
                        TYPES.BUSQUEDA_REPOSITORY
                    );

                    HelperLoading.showLoading();
                    const data = JSON.parse(JSON.stringify(dataSearchFilter.value));
                    _srv
                        .search(data as any, props.baseDatos, props.maxRegs)
                        .then((response) => {
                            dataSearchResult.value = JSON.parse(response?.items ?? '[]');
                            //generateFormatCol(JSON.parse(response?.items ?? '[]'))

                        })
                        .finally(() => {
                            HelperLoading.hideLoading();
                            hasLoadCustomSearchData.value = true
                        });
                }
            } else {
                hasLoadCustomSearchData.value = true
            }
            */
        }

        onMounted(() => {
            if (props.Component?.id) {
                debugger
                datasource.value = props.Component.iapComponentDataSources.find(x => x !== undefined)
                //const { getCatalogs, } = DataSourceComp(props.container as any, props, emit, {}, datasource.value as any,catalogos.value,store)
                var catalogoTipoIds = datasource.value?.dataSource.iapDataSourceFields.filter(x => x.catalogTypeId).map(x => x.catalogTypeId) ?? [];
                catalogoTipoIds.push(CatalogTypeConst.FILTROBUSQUEDA);
                const data = helperCatalog.getAllCatalogApp();
                catalogos.value = data.filter(x=> catalogoTipoIds.includes(x.id)).flatMap(x => x.iapCatalogs)
                doSearch()
                /*getCatalogs(catalogoTipoIds as any).then(response => {
                    catalogos.value = response;
                }).finally(() => {
                    doSearch()
                });
                */
            }

        });


        return {
            hasData,
            datasource,

            dataSearchFilter,
            dataSearchResult,
            catalogos,
            filterTables,
            hasLoadCustomSearchData
            , searchComp
            , doRefreshData
            , doSearch

        };
    },
});
